import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import RequisitionForm from "../Requisition/RequisitionNumberModal";
import AddMrvForm from "./AddMrvForm";
import Swal from 'sweetalert2';

const Orders = ({ onSuccess }) => {
  // Part numbers allowed to receive more than approved qty
  const ALLOWED_EXCESS_PARTS = [
    '20634', '20635', '20636', '20637', '20638',
    '20639', '21766', '23470', '23471', '23472'
  ];

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();
  const [selectedSupplier, setSelectedSupplier] = useState('');

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [mrv, setMrv] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState([]);
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    { name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: "", damageQty: 0, error: "", unit: "", remark: "", rateAtReceipt: 0, sgstAtReceipt: 0, cgstAtReceipt: 0, igstAtReceipt: 0 },
  ]);
  const [partOptions, setPartOptions] = useState([]);

  const handleAddItem = (e) => {
    e.preventDefault();
    const lastItem = items[items.length - 1];

    // Check for required fields
    // Check for required fields
    if (
      !lastItem ||
      !lastItem.id ||
      !lastItem.name ||
      lastItem.recivedQty <= 0 ||
      !lastItem.remark ||
      lastItem.remark.trim() === ""
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Item',
        text: 'Please fill all fields including Remark before adding a new item.',
        confirmButtonText: 'OK'
      });
      return;
    }

    setItems([
      ...items,
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,
        recivedQty: "",
        damageQty: 0,
        error: "",
        unit: "",
        remark: "",
        rateAtReceipt: 0,
        cgstAtReceipt: 0,
        sgstAtReceipt: 0,
        igstAtReceipt: 0
      },
    ]);
  };

  const handleItemChange = (
    index,
    field,
    value
  ) => {
    const newItems = [...items];

    /*
     * Damage quantity is currently disabled.
     * Always keep it zero.
     */
    if (field === "damageQty") {
      newItems[index].damageQty = 0;
      setItems(newItems);
      return;
    }

    const numericFields = [
      "recivedQty",
      "rateAtReceipt",
      "cgstAtReceipt",
      "sgstAtReceipt",
      "igstAtReceipt"
    ];

    const finalValue =
      numericFields.includes(field)
        ? value === ""
          ? ""
          : Number(value)
        : value;

    newItems[index][field] =
      finalValue;

    // ======================================
    // RECEIVED QUANTITY VALIDATION
    // ======================================

    if (field === "recivedQty") {
      const partNo =
        newItems[index]
          .partNo
          ?.toString();

      const approveQty =
        Number(
          newItems[index].approveQty || 0
        );

      /*
       * Damage is disabled and must
       * always remain zero.
       */
      newItems[index].damageQty = 0;

      let maxEligibleQty =
        approveQty;

      if (
        ALLOWED_EXCESS_PARTS.includes(
          partNo
        )
      ) {
        maxEligibleQty =
          approveQty +
          approveQty * 0.05;
      }

      if (
        finalValue === ""
      ) {
        newItems[index].error =
          "Received Qty is required.";
      } else if (
        !Number.isFinite(
          Number(finalValue)
        )
      ) {
        newItems[index].error =
          "Received Qty must be a valid number.";
      } else if (
        Number(finalValue) <= 0
      ) {
        newItems[index].error =
          "Received Qty must be greater than 0.";
      } else if (
        Number(finalValue) >
        maxEligibleQty
      ) {
        newItems[index].error =
          `Received Qty cannot exceed ${maxEligibleQty.toFixed(2)} for this item.`;
      } else {
        newItems[index].error = "";
      }
    }

    setItems(newItems);
  };

  const handlePartSelect = async (
    index,
    selectedOption
  ) => {
    if (!selectedOption) {
      return;
    }

    // ======================================
    // 1. DUPLICATE ITEM VALIDATION
    // ======================================

    const isDuplicate = items.some(
      (item, itemIndex) =>
        itemIndex !== index &&
        item.id === selectedOption.value
    );

    if (isDuplicate) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Item",
        text: "This item has already been added.",
        confirmButtonText: "OK"
      });

      return;
    }

    // ======================================
    // 2. GET EXISTING PO + SUPPLIER DETAILS
    // Exclude the current row
    // ======================================

    const existingPOData = items
      .filter(
        (item, itemIndex) =>
          itemIndex !== index &&
          item.id &&
          item.poNumber !== undefined &&
          item.poNumber !== null &&
          item.poNumber !== ""
      )
      .map((item) => ({
        poNumber: String(item.poNumber),
        supplierName:
          item.supplierName || "N/A"
      }));

    const existingPONumbers = [
      ...new Set(
        existingPOData.map(
          (item) => item.poNumber
        )
      )
    ];

    const selectedPONumber =
      selectedOption.poNumber !== undefined &&
        selectedOption.poNumber !== null
        ? String(selectedOption.poNumber)
        : "";

    const selectedSupplierName =
      selectedOption.supplierName ||
      "N/A";

    // ======================================
    // 3. DIFFERENT PO CONFIRMATION
    // ======================================

    const isDifferentPO =
      existingPONumbers.length > 0 &&
      selectedPONumber &&
      !existingPONumbers.includes(
        selectedPONumber
      );

    if (isDifferentPO) {
      const existingDetailsHtml = [
        ...new Map(
          existingPOData.map((item) => [
            `${item.poNumber}-${item.supplierName}`,
            item
          ])
        ).values()
      ]
        .map(
          (item) => `
          <div style="
            border:1px solid #dee2e6;
            border-radius:6px;
            padding:8px 10px;
            margin-bottom:6px;
            background:#f8f9fa;
          ">
            <div>
              <strong>PO No.:</strong>
              ${item.poNumber}
            </div>

            <div>
              <strong>Supplier:</strong>
              ${item.supplierName}
            </div>
          </div>
        `
        )
        .join("");

      const result = await Swal.fire({
        icon: "warning",
        title: "Different PO Selected",

        html: `
        <div style="text-align:left">

          <p style="margin-bottom:6px">
            <strong>Existing selected item:</strong>
          </p>

          ${existingDetailsHtml}

          <p style="margin-top:14px; margin-bottom:6px">
            <strong>New selected item:</strong>
          </p>

          <div style="
            border:1px solid #ffc107;
            border-radius:6px;
            padding:8px 10px;
            background:#fff8e1;
          ">
            <div>
              <strong>PO No.:</strong>
              ${selectedPONumber || "N/A"}
            </div>

            <div>
              <strong>Supplier:</strong>
              ${selectedSupplierName}
            </div>
          </div>

          <p style="margin-top:14px; margin-bottom:0">
            Do you want to add this item from a different PO?
          </p>
        </div>
      `,

        showCancelButton: true,

        confirmButtonText:
          "Yes, Continue",

        cancelButtonText:
          "Cancel",

        reverseButtons: true,
        focusCancel: true
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    // ======================================
    // 4. APPLY SELECTED ITEM TO ROW
    // ======================================

    setItems((previousItems) =>
      previousItems.map(
        (item, itemIndex) => {
          if (itemIndex !== index) {
            return item;
          }

          return {
            ...item,

            id:
              selectedOption.value,

            partNo:
              selectedOption.partNo,

            name:
              selectedOption.label,

            approveQty:
              selectedOption.approveQty,

            qtyRequired:
              selectedOption.qtyRequired,

            description:
              selectedOption.description,

            unit:
              selectedOption.unit,

            poNumber:
              selectedOption.poNumber,

            poType:
              selectedOption.poType,

            supplierName:
              selectedOption.supplierName,

            recivedQty: "",
            damageQty: 0,
            error: "",
            remark: "",
            rateAtReceipt: 0,
            cgstAtReceipt: 0,
            sgstAtReceipt: 0,
            igstAtReceipt: 0
          };
        }
      )
    );
  };

  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  useEffect(() => {
    if (!selectedStore) return;

    setItems([{
      name: "",
      id: "",
      description: "",
      approveQty: 0,
      qtyRequired: 0,
      recivedQty: "",
      damageQty: 0,
      error: "",
      unit: "",
      remark: "",
      rateAtReceipt: 0,
      cgstAtReceipt: 0,
      sgstAtReceipt: 0,
      igstAtReceipt: 0
    }]);

    RequestServies.getMrv(selectedStore)
      .then((res) => {
        const allMrv = res?.data?.data || [];

        const supplierMrv = allMrv.filter(mrv =>
          mrv.supplier &&
          !mrv.supplier?.name?.toLowerCase().startsWith("local")
        );

        setMrv(supplierMrv);

        if (supplierMrv.length > 0) {
          setSelectedMrv(supplierMrv[0]._id);
          setSelectedSupplier(supplierMrv[0]?.supplier?._id);
        } else {
          // ✅ IMPORTANT: no MRV → no supplier → no items
          setSelectedMrv("");
          setSelectedSupplier("");
          setPartOptions([]);
        }
      })
      .catch(console.log);
  }, [selectedStore, run]);


  useEffect(() => {
    // ✅ HARD BLOCK when MRV or Supplier missing
    if (!selectedStore || !selectedSupplier || !selectedMrv) {
      setPartOptions([]);
      return;
    }

    const status = 'approved';
    const poStatus = 'generated';

    RequestServies.getAllItem(undefined, status, selectedStore, poStatus)
      .then((res) => {
        const filtered = res?.data?.data?.filter(
          part => part?.po?.items?.[0]?.supplier?._id === selectedSupplier
        );

        const options = filtered.map((part) => ({
          value: part?._id,
          label: `${part?.inventory?.masterItem?.partNo} | ${part?.inventory?.masterItem?.description}`,
          approveQty: part?.approveQty,
          description: part?.inventory?.masterItem?.description,
          qtyRequired: part?.qtyRequired,
          unit: part?.inventory?.masterItem?.unit?.name,
          poNumber: part?.po?.poNumber,
          poType: part?.po?.poType,          // ✅ NEW
          supplierName: part?.po?.items?.[0]?.supplier?.name,
          partNo: part?.inventory?.masterItem?.partNo,
        }));

        setPartOptions(options);
      })
      .catch(console.log);
  }, [selectedStore, selectedSupplier, selectedMrv, run]);


  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    // ======================================
    // PREVENT DUPLICATE ITEMS
    // ======================================

    const uniqueIds = new Set();

    for (const item of items) {
      if (!item.id) {
        isValid = false;
        errorMessage = "Please select an item.";
        break;
      }

      if (uniqueIds.has(item.id)) {
        isValid = false;
        errorMessage =
          `Duplicate item detected: ${item.name || item.id}`;
        break;
      }

      uniqueIds.add(item.id);
    }

    // ======================================
    // VALIDATE ITEMS
    // ======================================

    if (isValid) {
      for (
        let index = 0;
        index < items.length;
        index++
      ) {
        const item =
          items[index];

        const approveQty =
          Number(
            item.approveQty || 0
          );

        const receivedQty =
          Number(
            item.recivedQty
          );

        /*
         * Damage quantity is currently disabled.
         * It must always remain zero.
         */
        const damageQty = 0;

        const partNo =
          item.partNo?.toString();

        const isFOCPO =
          item.poType === "FOC PO";

        let maxEligibleQty =
          approveQty;

        /*
         * Selected parts can be received
         * up to 5% above approved quantity.
         */
        if (
          ALLOWED_EXCESS_PARTS.includes(
            partNo
          )
        ) {
          maxEligibleQty =
            approveQty +
            approveQty * 0.05;
        }

        // ====================================
        // 1. ITEM VALIDATION
        // ====================================

        if (
          !item.id
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Please select an item.`;

          break;
        }

        // ====================================
        // 2. RECEIVED QTY REQUIRED
        // ====================================

        if (
          item.recivedQty === "" ||
          item.recivedQty === undefined ||
          item.recivedQty === null ||
          !Number.isFinite(receivedQty)
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Please enter a valid Received Qty.`;

          break;
        }

        // ====================================
        // 3. RECEIVED QTY MUST BE > 0
        // ====================================

        if (
          receivedQty <= 0
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Received Qty must be greater than 0.`;

          break;
        }

        // ====================================
        // 4. RECEIVED QTY MAX LIMIT
        // ====================================

        if (
          receivedQty >
          maxEligibleQty
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1} (${partNo || "-"}): Received Qty (${receivedQty}) cannot exceed ${maxEligibleQty.toFixed(2)}.`;

          break;
        }

        // ====================================
        // 5. DAMAGE QTY MUST REMAIN ZERO
        // ====================================


        // ====================================
        // 6. MRV VALIDATION
        // ====================================

        if (
          !selectedMrv
        ) {
          isValid = false;

          errorMessage =
            "MRV Not Selected!";

          break;
        }

        // ====================================
        // 7. REMARK VALIDATION
        // ====================================

        if (
          !item.remark ||
          item.remark.trim() === ""
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Remark is required.`;

          break;
        }

        // ====================================
        // 8. RATE VALIDATION
        // FOC PO CAN HAVE ZERO RATE
        // ====================================

        if (
          !isFOCPO &&
          (
            item.rateAtReceipt === "" ||
            item.rateAtReceipt === undefined ||
            item.rateAtReceipt === null ||
            !Number.isFinite(
              Number(
                item.rateAtReceipt
              )
            ) ||
            Number(
              item.rateAtReceipt
            ) <= 0
          )
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Rate must be greater than 0.`;

          break;
        }

        // ====================================
        // 9. GST VALUES
        // ====================================

        const cgst =
          Number(
            item.cgstAtReceipt || 0
          );

        const sgst =
          Number(
            item.sgstAtReceipt || 0
          );

        const igst =
          Number(
            item.igstAtReceipt || 0
          );

        if (
          !Number.isFinite(cgst) ||
          !Number.isFinite(sgst) ||
          !Number.isFinite(igst)
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: GST values must be valid numbers.`;

          break;
        }

        // ====================================
        // 10. GST CANNOT BE NEGATIVE
        // ====================================

        if (
          cgst < 0 ||
          sgst < 0 ||
          igst < 0
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: GST values cannot be negative.`;

          break;
        }

        // ====================================
        // 11. GST CANNOT EXCEED 100
        // ====================================

        if (
          cgst > 100 ||
          sgst > 100 ||
          igst > 100
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: GST values cannot exceed 100%.`;

          break;
        }

        // ====================================
        // 12. IGST OR CGST + SGST
        // ====================================

        if (
          igst > 0 &&
          (
            cgst > 0 ||
            sgst > 0
          )
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Enter either IGST or CGST + SGST, not both.`;

          break;
        }

        // ====================================
        // 13. CGST AND SGST TOGETHER
        // ====================================

        if (
          (
            cgst > 0 &&
            sgst === 0
          ) ||
          (
            sgst > 0 &&
            cgst === 0
          )
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Both CGST and SGST are required together.`;

          break;
        }

        // ====================================
        // 14. CGST AND SGST MUST BE EQUAL
        // ====================================

        if (
          cgst > 0 &&
          sgst > 0 &&
          cgst !== sgst
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: CGST and SGST should be equal.`;

          break;
        }
      }
    }

    // ======================================
    // SHOW VALIDATION ERROR
    // ======================================

    if (!isValid) {
      Swal.fire({
        title:
          "Error!",

        text:
          errorMessage,

        icon:
          "error",

        confirmButtonText:
          "OK"
      });

      return;
    }

    // ======================================
    // PREPARE SAFE REQUEST ITEMS
    // ======================================

    const requestItems =
      items.map((item) => ({
        ...item,

        /*
         * Force damage quantity to zero,
         * even if stale state contains another value.
         */
        damageQty:
          0,

        recivedQty:
          Number(
            item.recivedQty
          ),

        approveQty:
          Number(
            item.approveQty || 0
          ),

        qtyRequired:
          Number(
            item.qtyRequired || 0
          ),

        rateAtReceipt:
          Number(
            item.rateAtReceipt || 0
          ),

        cgstAtReceipt:
          Number(
            item.cgstAtReceipt || 0
          ),

        sgstAtReceipt:
          Number(
            item.sgstAtReceipt || 0
          ),

        igstAtReceipt:
          Number(
            item.igstAtReceipt || 0
          ),

        remark:
          String(
            item.remark || ""
          ).trim()
      }));

    const requestData = {
      mrvId:
        selectedMrv,

      items:
        requestItems
    };

    // ======================================
    // SUBMIT MRV
    // ======================================

    RequestServies
      .submitMrv(
        requestData
      )
      .then(() => {
        Swal.fire({
          title:
            "Success!",

          text:
            "Order has been Received Successfully",

          icon:
            "success",

          confirmButtonText:
            "OK"
        });

        setItems([
          {
            name:
              "",

            id:
              "",

            description:
              "",

            approveQty:
              0,

            qtyRequired:
              0,

            recivedQty:
              0,

            damageQty:
              0,

            error:
              "",

            unit:
              "",

            remark:
              "",

            rateAtReceipt:
              0,

            cgstAtReceipt:
              0,

            sgstAtReceipt:
              0,

            igstAtReceipt:
              0
          }
        ]);

        setRun(
          (prev) =>
            prev + 1
        );
      })
      .catch((error) => {
        console.log(
          "Error during submission:",
          error
        );

        Swal.fire({
          title:
            "Error!",

          text:
            error?.response?.data?.message ||
            "Error during submission",

          icon:
            "error",

          confirmButtonText:
            "OK"
        });
      });
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };

  const handleRequisitionForm = () => {
    setIsModelOpen(true);
  };

  const handleMrv = (selected) => {
    const mrvId = selected?.value || "";
    const supplierId = selected?.supplierId || "";

    console.log("Selected MRV:", mrvId);
    console.log("Selected Supplier:", supplierId);

    setSelectedMrv(mrvId);
    setSelectedSupplier(supplierId);

    // Reset selected item rows when MRV changes
    setItems([
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,
        recivedQty: "",
        damageQty: 0,
        error: "",
        unit: "",
        remark: "",
        rateAtReceipt: 0,
        cgstAtReceipt: 0,
        sgstAtReceipt: 0,
        igstAtReceipt: 0,
        poNumber: "",
        poType: "",
        supplierName: ""
      }
    ]);

    setPartOptions([]);
  };

  useEffect(() => {
    setPartOptions([]);
  }, [selectedMrv]);

  return (
    <>
      <AddMrvForm
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4">
                      <label>Select Store</label>

                      <Select
                        className="mb-xl-0 mb-3"
                        options={stores.map((store) => ({
                          value: store._id,
                          label: store.name,
                        }))}
                        value={
                          stores
                            .map((store) => ({
                              value: store._id,
                              label: store.name,
                            }))
                            .find((opt) => opt.value === selectedStore) || null
                        }
                        onChange={(selected) =>
                          handleStoreChange({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Search Store..."
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4">
                      <label>Select MRV No.</label>

                      <Select
                        className="mb-xl-0 mb-3"

                        options={
                          mrv.length > 0
                            ? mrv.map((m) => ({
                              value: m._id,

                              label: `${m.mrvNo} | ${m.supplier?.name || "N/A"} | Bill No: ${m.billingNo || "N/A"
                                }`,

                              // ✅ IMPORTANT
                              supplierId: m.supplier?._id || ""
                            }))
                            : []
                        }

                        value={
                          mrv
                            .map((m) => ({
                              value: m._id,

                              label: `${m.mrvNo} | ${m.supplier?.name || "N/A"} | Bill No: ${m.billingNo || "N/A"
                                }`,

                              supplierId: m.supplier?._id || ""
                            }))
                            .find(
                              (option) =>
                                String(option.value) === String(selectedMrv)
                            ) || null
                        }

                        // ✅ Pass react-select object directly
                        onChange={handleMrv}

                        placeholder="Search MRV No..."
                        noOptionsMessage={() => "No records found"}
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4 d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary w-100"
                        onClick={handleRequisitionForm}
                      >
                        Generate New MRV No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Add
                MRV Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-2">
                              <label>Part Number</label>
                              <Select
                                options={partOptions}

                                value={
                                  item.id
                                    ? partOptions.find(
                                      (option) =>
                                        option.value === item.id
                                    ) || null
                                    : null
                                }

                                onChange={(selectedOption) =>
                                  handlePartSelect(
                                    index,
                                    selectedOption
                                  )
                                }

                                placeholder="Part"

                                menuPortalTarget={
                                  document.body
                                }

                                filterOption={(
                                  option,
                                  inputValue
                                ) =>
                                  option.label
                                    ?.toLowerCase()
                                    .includes(
                                      inputValue.toLowerCase()
                                    )
                                }

                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth: 90,
                                    height: 14,
                                    fontSize: "12px"
                                  }),

                                  valueContainer: (base) => ({
                                    ...base,
                                    height: "100%"
                                  }),

                                  input: (base) => ({
                                    ...base,
                                    height: "auto"
                                  }),

                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                  })
                                }}
                              />
                            </div>


                            <div className="form-group mb-2 col-md-2">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description}
                                placeholder="Description"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Required Qty (${item.unit})` : `Required Qty`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="qtyRequired"
                                value={item.qtyRequired}
                                placeholder="Required Qty"
                                readOnly
                              />

                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Approved (${item.unit})` : `Approved`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="approveQty"
                                value={item.approveQty}
                                placeholder="approveQty"
                                readOnly
                              />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Received Qty (${item.unit})` : `Received Qty`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="recivedQty"
                                value={item.recivedQty}
                                min="0.01"
                                step="any"
                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }
                                onFocus={(event) =>
                                  event.target.select()
                                }
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "recivedQty",
                                    event.target.value
                                  )
                                }
                                placeholder="Enter Received Qty"
                              />
                              {item.error && <p className="text-danger mb-0">{item.error}</p>}
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit
                                  ? `Damage (${item.unit})`
                                  : "Damage"}
                              </label>

                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="damageQty"
                                value={0}
                                readOnly
                                disabled
                                tabIndex={-1}
                              />

                              <small className="text-muted">
                                Damage quantity is currently disabled
                              </small>
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>PO Number</label>
                              <input type="text" className="form-control form-control-sm" value={item.poNumber || ''} readOnly />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>Supplier</label>
                              <input type="text" className="form-control form-control-sm" value={item.supplierName || ''} readOnly />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Rate</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item.rateAtReceipt || ""}
                                onChange={(e) =>
                                  handleItemChange(index, "rateAtReceipt", e.target.value)
                                }
                              />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>CGST %</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item.cgstAtReceipt || ""}
                                disabled={Number(item.igstAtReceipt || 0) > 0}
                                onChange={(e) =>
                                  handleItemChange(index, "cgstAtReceipt", e.target.value)
                                }
                              />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>SGST %</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item.sgstAtReceipt || ""}
                                disabled={Number(item.igstAtReceipt || 0) > 0}
                                onChange={(e) =>
                                  handleItemChange(index, "sgstAtReceipt", e.target.value)
                                }
                              />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>IGST %</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={item.igstAtReceipt || ""}
                                disabled={
                                  Number(item.cgstAtReceipt || 0) > 0 ||
                                  Number(item.sgstAtReceipt || 0) > 0
                                }
                                onChange={(e) =>
                                  handleItemChange(index, "igstAtReceipt", e.target.value)
                                }
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="remark"
                                value={item.remark}
                                onChange={(event) =>
                                  handleItemChange(index, "remark", event.target.value)
                                }
                                placeholder="Remark"
                              />
                            </div>


                            <div className="form-group mb-1 col-md-1">

                              <button className="btn btn-danger btn-xs sharp mt-1"
                                onClick={(e) => handleRemoveItem(e, index)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                        <div className="row">
                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={(e) => handleAddItem(e)}
                            >
                              Add Item
                            </button>
                          </div>

                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
